class Viewport{
  
  
  get viewport () {
    return {
      height: window.innerHeight,
      width: window.innerWidth,
      // offsetLeft: 0,
      // offsetTop: 0,
      pageLeft: window.pageXOffset,
      pageRight: window.pageXOffset + window.innerWidth,
      pageTop: window.pageYOffset,
      pageBottom: window.pageYOffset + window.innerHeight,
    }
  }
}

const VisualPage = new Viewport();


export {VisualPage};
